import { useState } from 'react';
import PropTypes from 'prop-types';
import CommentItem from './commentItem';
import AddComment from '../addComment';
import AlertDialog from '../alertDialog';
import { ONE_ON_ONE_COMMENT_FIELDS } from '../../../constants/oneOnOne';

const UsersComments = ({
  className = undefined,
  translations,
  currentUser,
  commentId = -1,
  comments,
  isRichText = false,
  onSendComment = () => {},
  canEditCommentCheck = () => {},
  canDeleteCommentCheck,
  openEditComment = () => {},
  closeEditComment = () => {},
  onDeleteComment = () => {},
}) => {
  const { CREATOR } = ONE_ON_ONE_COMMENT_FIELDS;

  const [isDeleteCommentOpened, setIsDeleteCommentOpened] = useState(false);
  const [currentCommentId, setCurrentCommentId] = useState(null);
  const [isFocused, setIsFocused] = useState(false);

  const handleDeleteComment = commId => {
    setIsDeleteCommentOpened(true);
    setCurrentCommentId(commId);
  };

  const onCancelDelete = () => {
    setIsDeleteCommentOpened(false);
    setCurrentCommentId(null);
  };

  const onDelete = () => {
    onDeleteComment(currentCommentId);
    onCancelDelete();
  };

  const canEditComment = currentComment =>
    currentComment[CREATOR]?.id === currentUser.id;

  const handleFocus = (value = false) => setIsFocused(value);

  return (
    <div className={className}>
      <>
        <AddComment
          className="no-print"
          translations={translations.addComment}
          currentUser={currentUser}
          onSendComment={onSendComment}
          closeEditComment={closeEditComment}
          isRichText={isRichText}
          handleFocus={handleFocus}
          isFocusedAdd={isRichText}
        />
        {comments.map(comment => (
          <CommentItem
            key={`comment_item_${comment.id}`}
            translations={translations}
            comment={comment}
            canEditComment={canEditComment(comment)}
            canManageComment={canEditCommentCheck(comment)}
            currentUser={currentUser}
            canDeleteComment={canDeleteCommentCheck(comment)}
            onSendComment={onSendComment}
            isEdit={commentId === comment.id}
            onCommentDelete={handleDeleteComment}
            openEditComment={openEditComment}
            closeEditComment={closeEditComment}
            isRichText={isRichText}
            handleFocus={handleFocus}
            isFocused={isFocused}
          />
        ))}
      </>
      <AlertDialog
        isOpened={isDeleteCommentOpened}
        translations={translations.deleteCommentDialog}
        onClose={onCancelDelete}
        onConfirm={onDelete}
        isWarning
      />
    </div>
  );
};

UsersComments.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.shape({}).isRequired,
  currentUser: PropTypes.shape({}).isRequired,
  commentId: PropTypes.number,
  comments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isRichText: PropTypes.bool,
  canEditCommentCheck: PropTypes.func,
  canDeleteCommentCheck: PropTypes.func.isRequired,
  onSendComment: PropTypes.func,
  onDeleteComment: PropTypes.func,
  openEditComment: PropTypes.func,
  closeEditComment: PropTypes.func,
};

export default UsersComments;
